// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__3U-ZQ"};